// @ts-nocheck

import { createSelector } from 'reselect';

import { selectBasketIsCashout } from '../../selectors/basket/basketPrimary.selector';
import { selectBetshareBasketBetslipReference } from '../../selectors/basketCommon.selector';
import {
  selectBasketShowResume,
  selectBasketShouldShowMainBetConfirmation,
} from '../../selectors/basketCommon.selector';
import { getNbItems } from '../../selectors/basketItems.selector';

const selectBasketHeaderProps = createSelector(
  [
    getNbItems,
    selectBasketIsCashout,
    selectBetshareBasketBetslipReference,
    selectBasketShowResume,
    selectBasketShouldShowMainBetConfirmation,
  ],
  (nbSelection, isCashout, betshareBetslipReference, isResume, hasConfirmation) => ({
    nbSelection,
    isCashout,
    betshareBetslipReference,
    isResume,
    hasConfirmation,
  }),
);

export default selectBasketHeaderProps;
